import { DocumentType } from '@synergy/models';

export const getDocumentTranslationId = (documentType: DocumentType): string => {
    const rawKey = DocumentType[documentType];
    const key = rawKey.charAt(0).toLowerCase() + rawKey.slice(1);
    return 'app.document.' + key;
};
